import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-slate-950 px-4 py-16 text-white">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="text-sm text-white/60 underline hover:text-white">&larr; Back to AnoteQuest</Link>
        <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-amber-300">Legal</p>
        <h1 className="mt-3 text-4xl font-semibold">Privacy Policy</h1>
        <p className="mt-2 text-sm text-white/50">Last updated: July 21, 2026</p>

        <div className="mt-10 space-y-8 text-white/85">
          <section>
            <h2 className="text-xl font-semibold text-white">1. What we collect</h2>
            <p className="mt-3 leading-7">
              When you create a synced AnoteQuest account, we collect your email address and the
              content you save (notes, boards, images, and related metadata) so it can sync across your
              devices. If you choose local-only mode, your content stays on your device and is not sent
              to our servers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">2. How we use it</h2>
            <p className="mt-3 leading-7">
              We use your information to operate your account, sync your content across devices,
              process subscription payments, and send you essential account or service emails. We do
              not sell your personal data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">3. Third-party services</h2>
            <p className="mt-3 leading-7">
              We rely on a small number of trusted providers to run AnoteQuest: PayPal for subscription
              billing, and Cloudflare R2 for object storage of uploaded images. These providers process
              data on our behalf under their own privacy and security practices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">4. Data storage and security</h2>
            <p className="mt-3 leading-7">
              Synced content is stored on our infrastructure with reasonable technical safeguards.
              Local-only content lives entirely in your browser/device storage and is your
              responsibility to back up.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">5. Your choices</h2>
            <p className="mt-3 leading-7">
              You can switch to local-only mode at any time to keep future content off our servers, and
              you can request deletion of your account and synced data by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">6. Cookies and analytics</h2>
            <p className="mt-3 leading-7">
              We use minimal, functional cookies/local storage to keep you signed in and remember your
              preferences (like light/dark mode), and basic analytics to understand how the product is
              used.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">7. Changes to this policy</h2>
            <p className="mt-3 leading-7">
              We may update this policy as AnoteQuest evolves. We'll update the "Last updated" date
              above when we do.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">8. Contact</h2>
            <p className="mt-3 leading-7">
              Questions about your data or this policy? Reach out at{" "}
              <a href="mailto:support@anotequest.com" className="text-amber-300 underline hover:text-amber-200">
                support@anotequest.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
